import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRolesRetrievalRequestFailure({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isRolesRetrievalRequestPending({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isRolesRetrievalRequestSuccess({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
    getRoles({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.roles : [];
    },
  };
}

export { createSelector };
